import TitleMentionTag from '../TitleMentionTag/TitleMentionTag';
import { titleTagRegExGlobal } from '../util/titleTag/regex';
import React from 'react';
import PropTypes from 'prop-types';
import './parsedComment.less';
import classNames from 'classnames';
import Linkify from 'react-linkify';

ParsedComment.propTypes = {
	commentText: PropTypes.string,
	mentionPopoverPlacement: PropTypes.string,
	toTruncate: PropTypes.bool,
};

ParsedComment.defaultProps = {
	mentionPopoverPlacement: 'top',
	toTruncate: false,
};

export default function ParsedComment({
	commentText,
	mentionPopoverPlacement,
	toTruncate,
}) {
	const parsedCommentRef = React.useRef(null);
	const [displayShowMore, setDisplayShowMore] = React.useState(false);
	const [isExpanded, setIsExpanded] = React.useState(false);
	let isTruncated =
		toTruncate &&
		parsedCommentRef &&
		parsedCommentRef.current &&
		parsedCommentRef.current.offsetHeight <
			parsedCommentRef.current.scrollHeight;

	React.useEffect(() => {
		setDisplayShowMore(isTruncated);
	}, [isTruncated]);

	const getTitleTags = () => {
		const titleTags = commentText && commentText.match(titleTagRegExGlobal);
		return titleTags;
	};

	const getCommentSplitAtTag = () => {
		const commentSplitAtTag =
			commentText && commentText.split(titleTagRegExGlobal);
		return commentSplitAtTag;
	};

	const renderTitleTagComponent = titleTag => {
		return (
			<TitleMentionTag
				titleTag={titleTag}
				popoverPlacement={mentionPopoverPlacement}
			/>
		);
	};

	const titleTags = getTitleTags(commentText);

	const splitComment = getCommentSplitAtTag(commentText);

	const getCommentSubClasses = () =>
		classNames({ 'truncated-comment': !isExpanded && toTruncate });

	const showMoreButton = (
		<div
			className="clickable show-more-button"
			onClick={() => setIsExpanded(!isExpanded)}>
			{isExpanded ? 'show less' : 'show more'}
		</div>
	);

	const getComponentDecorator = (href, text, key) => (
		<a
			className="acc-font"
			href={href}
			key={key}
			target="_blank"
			rel="noopener noreferrer">
			{text}
		</a>
	);

	return (
		<div className="parsed-comment">
			<div className={getCommentSubClasses()} ref={parsedCommentRef}>
				{splitComment &&
					splitComment.map((subStr, index) => (
						<React.Fragment key={index}>
							<Linkify componentDecorator={getComponentDecorator}>
								{subStr}
							</Linkify>
							{titleTags && titleTags[index]
								? renderTitleTagComponent(titleTags[index])
								: null}
						</React.Fragment>
					))}
			</div>
			{displayShowMore && showMoreButton}
		</div>
	);
}
